<template>
    <div class="card-header" :class="color_class"><slot></slot></div>
</template>

<script>
    export default {
        props: {
            color: {default: ''},
        },
        data() {
            return {
                text_class: 'text-white'
            }
        },
        computed: {
            color_class() {
                if (['', 'warning', 'light', 'white'].includes(this.color)) {
                    this.text_class = 'text-dark'
                }
                return `bg-${this.color} ${this.text_class}`
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-header {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
</style>
